import { useNavigate } from "react-router";
import Com1 from "./components/Com1";
import Com2 from "./components/Com2";
import Com3 from "./components/Com3";
import { BtnWrapper, HomeBtn, Wrapper } from "./style";
import Com4 from "./components/Com4";
import Com5 from "./components/Com5";
import Com6 from "./components/Com6";
import { useTranslation } from "react-i18next";
import { useNavigatePage } from "hooks/useNavigatePage";
const Landing = () => {
  const nav = useNavigatePage();
  const navHandler = () => {
    nav("/home");
  };
  const { t } = useTranslation("landing");
  return (
    <Wrapper>
      <BtnWrapper>
        <HomeBtn onClick={navHandler}>
          <span>{t("btn")}</span>
          <img loading="lazy" src="/assets/img/Landing_2.svg" alt="" />
        </HomeBtn>
      </BtnWrapper>
      <Com1 t={t} />
      <Com2 t={t} />
      <Com3 t={t} />
      <Com4 t={t} />
      <Com5 t={t} />
      <Com6 t={t} />
    </Wrapper>
  );
};

export default Landing;
